import { getGenericEndpoint } from './get.api';
import type { GetSignoutResponse } from './types';

export const getSignout = async (lang?: string) => {
	return await getGenericEndpoint<GetSignoutResponse>('signout', lang);
};
